import Mutations from '../../odata/mutations';

export default { ...new Mutations('vehicle'), ...new Mutations('vehicles') };
